import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import Grid from "@mui/material/Grid";
import InfoIcon from "@mui/icons-material/Info";
import { DocumentState } from "../../PermitApplicationContext/types";
import { DocumentUploadCard } from "../DocumentUploadCard";

export interface UploadDocumentsStepContentProps {
  documents: readonly DocumentState[];
  permitTypeName: string;
  payeeAccountId: string;
}

export const UploadDocumentsStepContent: React.FC<UploadDocumentsStepContentProps> = ({
  documents,
  permitTypeName,
  payeeAccountId,
}) => {
  if (documents.length === 0) {
    return (
      <Box>
        <Typography variant="h5" component="h2" sx={{ fontWeight: 600, mb: 1 }}>
          Upload Required Documents
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          {permitTypeName}
        </Typography>
        <Alert severity="info" icon={<InfoIcon />}>
          No documents are required for this permit type. You can proceed to the next step.
        </Alert>
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h5" component="h2" sx={{ fontWeight: 600, mb: 1 }}>
        Upload Required Documents
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Please upload the following documents for your {permitTypeName} application.
      </Typography>

      <Grid container spacing={2} sx={{ mb: 3 }}>
        {documents.map((doc) => (
          <Grid item xs={12} key={doc.documentTypeId}>
            <DocumentUploadCard
              documentTypeId={doc.documentTypeId}
              documentTypeName={doc.documentTypeName}
              documentTypeDescription={doc.documentTypeDescription}
              documentId={doc.documentId}
              payeeAccountId={payeeAccountId}
            />
          </Grid>
        ))}
      </Grid>

      <Alert severity="info" icon={<InfoIcon />} sx={{ mt: 2 }}>
        Make sure all documents are current, clearly legible, and show all required information. Accepted formats: PDF,
        JPG, PNG (max 10MB each).
      </Alert>
    </Box>
  );
};

export default UploadDocumentsStepContent;
